import axiosInstance from "../config/axios/axios.config";

export async function fetchData({
  endpoint,
  params = {},
  queryParams = new URLSearchParams(),
  errorFlag = "ApiError",
}) {
  let url = endpoint;

  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, encodeURIComponent(value));
  });

  if (queryParams.toString()) {
    url += `?${queryParams.toString()}`;
  }

  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    if (error?.flag === errorFlag) {
      return null;
    }
    throw new Error(
      `Failed to fetch data from ${url}. Error: ${error.message}`
    );
  }
}
